import { FC } from 'react';
import ModalWrap from '../../ModalWrap';
import { useIntl } from 'react-intl';
import { TimekeepingReport } from '../../../apis/client-axios';

interface ModalDeleteReportProps {
  open: boolean;
  timekeepingReport: TimekeepingReport;
  onCancel: () => void;
  onSubmit: (id: string) => void;
  isLoading: boolean;
}

const ModalDeleteReport: FC<ModalDeleteReportProps> = (props) => {
  const { open, timekeepingReport, isLoading, onCancel, onSubmit } = props;
  const intl = useIntl();
  const handleFormSubmit = () => {
    onSubmit(timekeepingReport.id);
  };

  return (
    <ModalWrap
      open={!!open}
      cancelText={intl.formatMessage({ id: 'common.cancel' })}
      submitText={intl.formatMessage({ id: 'common.delete' })}
      onSubmit={handleFormSubmit}
      onCancel={onCancel}
      type="delete"
      title={intl.formatMessage({ id: 'timekeepingReports.delete.title' })}
      buttonSubmitProps={{ loading: isLoading }}
      body={
        <div className="modal-block-user">
          <span>{intl.formatMessage({ id: `timekeepingReports.${timekeepingReport.type}` })}</span>
          <span>{intl.formatMessage({ id: 'timekeepingReports.delete.confirm' })}</span>
        </div>
      }
    />
  );
};

export default ModalDeleteReport;
